/**
 * IT-CONSULTING(자동화·기획) · 설정 메뉴의 영문 표시명 — 국문 코드 라벨을 키로.
 * 메뉴 관리에서 바꾼 이름은 맵에 없으니 그대로 나온다. CRM 메뉴는 crmLanguage 맵(resolveMenuLabel)이 맡는다.
 * 사이드바(AutomationLayout · SettingsLayout)와 메뉴 권한 관리 화면이 같은 맵을 쓴다.
 */
export const AUTOMATION_MENU_LABEL_EN: Record<string, string> = {
  "기획 관리": "Planning",
  "기획 문서 관리": "Planning Documents",
  "관리": "Management",
  "문서 작성": "Documents",
  "운영 관리": "Operations",
  "MOU 현황 관리": "MOU Status",
  "DB 관리": "DB Management",
  "문서 DB 관리": "Document DB",
  "가이드": "Guides",
  "진단 로직": "Diagnosis Logic",
  "인보이스 가이드": "Invoice Guide",
  "시뮬레이터": "Simulator",
  "서비스 기획": "Service Planning",
  "ROI 분석 도구": "ROI Analysis Tool",
  "브랜드 정산": "Brand Settlement",
  "브랜드501": "Brand501",
  "창고 3D Rack": "Warehouse 3D Rack",
  "디지털 트윈 스튜디오 (TEST)": "Digital Twin Studio (TEST)",
  "MWMS API 테스트": "MWMS API Test",
  "WMS Billing 시뮬레이터": "WMS Billing Simulator",
  "AI 회의록 자동화": "AI Meeting Notes",
  "Care Desk 접수·스케줄": "Care Desk Intake & Schedule",
  "HWP 서식 편집·출력": "HWP Form Edit & Print",
  "Task 관리": "Task Management",
  "설비 카탈로그": "Equipment Catalog",
  "제안서 빌더": "Proposal Builder",
  "MRO 편집샵(Vault)": "MRO Select Shop (Vault)",
  "현장 리서치": "Field Research",
  "행사": "Events",
  "질문 관리": "Questions",
};

export const SETTINGS_MENU_LABEL_EN: Record<string, string> = {
  "계정": "Account",
  "계정 설정": "Account Settings",
  "관리자": "Admin",
  "유저 관리": "User Management",
  "메뉴 권한 관리": "Menu Permissions",
  "문서 관리": "Document Settings",
  "조직 관리": "Organization",
  "마스터 데이터": "Master data",
  "공지 관리": "Announcements",
  "데이터 흐름": "Data Flow",
};

/** 메뉴 권한 관리 화면에만 나오는 머리 라벨(상단 네비 · 영역 루트) */
const MENU_ADMIN_LABEL_EN: Record<string, string> = {
  "설정": "Settings",
  "상단: CRM": "Top nav: CRM",
  "상단: IT-CONSULTING": "Top nav: IT-CONSULTING",
  "IT-CONSULTING (문서 자동화)": "IT-CONSULTING (Document automation)",
  "(이름 없음)": "(Untitled)",
};

/** 국문 코드 라벨 → 영문(언어가 en 일 때만). 맵에 없으면(관리자가 바꾼 이름 등) 그대로. */
export function menuLabelEn(label: string, language: string): string {
  if (language !== "en") return label;
  return AUTOMATION_MENU_LABEL_EN[label] ?? SETTINGS_MENU_LABEL_EN[label] ?? MENU_ADMIN_LABEL_EN[label] ?? label;
}
